import { render, staticRenderFns } from "./checklist_detail.vue?vue&type=template&id=10676181&"
import script from "./checklist_detail.vue?vue&type=script&lang=js&"
export * from "./checklist_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports